import { Suspense, lazy, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import PreloadAppData from "../../components/Utils/PreloadAppData";
import { CalendarStoreProvider } from "../../calendar/master";
import { isSuperiorInstructorType } from "../../constants/instructors";
import { useResolvedInstructor } from "../../hooks/useResolvedInstructor";
import { reservationsApi } from "../../store/reservationsApi";
import { canUseCalendarV2, newCalendarPathFor, readCalendarChoice } from "../../calendarV2/calendarV2Access";

const CalendarExtremeOptimized = lazy(() =>
   import("../../components/APanel/CalendarExtreme/ACalendarOptimized"),
);

function getUltraPrefetchDate() {
   try {
      const saved = localStorage.getItem("__DV_ULTRA_MONTH");
      if (saved && /^\d{4}-\d{2}$/.test(saved)) {
         const [year, month] = saved.split("-").map(Number);
         return new Date(year, month - 1, 1);
      }
   } catch {}
   return new Date();
}

function IPOrarPractic() {
   const dispatch = useDispatch();
   const { instructor, resolved, user } = useResolvedInstructor();

   useEffect(() => {
      document.title = "Instruire Auto | Orar practice";
      dispatch(
         reservationsApi.util.prefetch(
            "getReservationsForMonth",
            { date: getUltraPrefetchDate() },
            { force: false },
         ),
      );
   }, [dispatch]);

   // cine a ales calendarul nou ajunge direct acolo (din meniu „Orar practice”)
   if (user && canUseCalendarV2(user) && readCalendarChoice(user) === "v2") {
      return <Navigate to={newCalendarPathFor(user, { practice: true })} replace />;
   }

   if (user?.role === "INSTRUCTOR" && !resolved) {
      return (
         <main className="main" style={{ padding: 0 }}>
            <div className="dayview__loading" role="status" aria-live="polite">
               <div className="dayview__spinner" />
               <span>Se incarca Orar practice...</span>
            </div>
         </main>
      );
   }

   if (
      user?.role === "INSTRUCTOR" &&
      resolved &&
      !isSuperiorInstructorType(instructor?.instructorType)
   ) {
      return <Navigate to="/instructor/orarul-meu" replace />;
   }

   return (
      <main className="main" style={{ padding: 0 }}>
         <PreloadAppData />
         <Suspense
            fallback={
               <div className="dayview__loading" role="status" aria-live="polite">
                  <div className="dayview__spinner" />
                  <span>Se incarca Orar practice...</span>
               </div>
            }
         >
            <CalendarStoreProvider>
               <CalendarExtremeOptimized
                  canEditOrder={false}
                  canBlockSlot={false}
                  canWriteNotes={false}
                  canCreateReservation={true}
                  showTopWaitCancelZone={false}
                  studentProfileMode="superior-instructor"
               />
            </CalendarStoreProvider>
         </Suspense>
      </main>
   );
}

export default IPOrarPractic;
